export default () => ({
  paper: {
    color: '#db5ed7'
  },
  button: {
    backgroundColor: '#db5ed7'
  }
});
